module.exports = __webpack_public_path__ + "img/menulingua_logo_v2_icon_only.e87c84c9.svg";